import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { DEFAULT_SITE_TITLE } from '../components/SEO';
import '../styles/not-found.css';

export const NOT_FOUND_TITLE = 'Page not found — Feeling Froggy';

export default function NotFoundPage() {
  const location = useLocation();

  React.useEffect(() => {
    document.title = NOT_FOUND_TITLE;
    console.warn('[NotFound] 404 for path:', location.pathname);
  }, [location.pathname]);

  // Cowork 2026-10-23: the title set above outlived the 404 — every later
  // in-app route that sets no title of its own kept reading "Page not
  // found". When the 404 leaves, put the site's title back — but only if
  // the tab still reads ours (a next page that set its own title wins).
  React.useEffect(() => () => {
    if (document.title === NOT_FOUND_TITLE) document.title = DEFAULT_SITE_TITLE;
  }, []);

  // Cowork run 52: the page paints its own ground and its text from
  // tokens with a dark value (see not-found.css). The buttons are the
  // design system's own variants — no inline colour overrides them.
  return (
    <div className="ff-notfound">
      <div className="ff-notfound__inner">
        {/* role="heading" aria-level=1 rather than <h1>, because global.css
            has an `!important` rule forcing all h1..h6 to --ff-color-text. */}
        <div role="heading" aria-level="1" className="ff-notfound__code">
          404
        </div>
        <h2 className="ff-notfound__title">This page hopped away</h2>
        <p className="ff-notfound__body">
          We can't find <code>{location.pathname}</code>. It may have moved, or the
          link might have a typo.
        </p>
        <div className="ff-notfound__actions">
          <Link to="/" className="ff-btn ff-btn--primary">
            Return home
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="ff-btn ff-btn--secondary"
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}
